module.exports = __webpack_public_path__ + "img/banner2.02cad317.png";